import AssessmentExplorer from './AssessmentsExplorer';

export default AssessmentExplorer;
